<template>
<q-dialog
    ref="dialog"
    class="dialog"
    @hide="onDialogHide"
>
  <q-card class="q-dialog-plugin" style="width: 50vw">
    <common-form :action="$route('project.sync', projectId)" ref="syncForm">
      <q-card-section class="row items-center" :class="{'q-px-lg': $isDesktop}">
        <div class="heading-3 q-mr-sm">Project synchroniseren</div>
        <q-space />
        <icon-button icon="close" aria-label="Annuleren" size="sm" round v-close-popup />
      </q-card-section>
      <q-card-section class="dialog__messages editor-styling" :class="$isMobile ? 'q-pb-none' : 'q-px-lg q-pb-sm'">
        <p v-if="syncStatus.deleted_at">
          Het project is bij de externe bron in gearchiveerde status.
          Wilt u het project ook in het HIOR archiveren?
        </p>
        <template v-else>
          <p>De volgende velden kunnen worden bijgewerkt vanuit de externe bron:</p>
          <ul class="ul">
            <li v-if="syncStatus.geometry">Het kaartvlak</li>
            <li v-if="syncStatus.current_phase">De active fase</li>
          </ul>
        </template>
        <input v-if="doUpdateRules" type="hidden" name="doUpdateRules" :value="1">
      </q-card-section>
      <q-separator />
      <q-card-actions :class="$isMobile ? 'q-pa-md' : 'q-px-lg q-py-md'">
        <slot name="actions">
          <warning-button v-if="syncStatus.deleted_at"
                          label="Archiveer"
                          @click="doSync" />
          <template v-else>
            <accent-button
                label="Synchroniseer"
                @click="doSync(false)"
            />
            <accent-button
                v-if="syncStatus.geometry"
                label="Synchroniseer en werk richtlijnen bij"
                @click="doSync(true)"
            />
          </template>
          <flat-button
              label="Annuleren"
              @click="onCancelClick"
          />
        </slot>
      </q-card-actions>
    </common-form>
  </q-card>
</q-dialog>
</template>

<script>

import AccentButton from '../button/AccentButton.vue'
import WarningButton from '../button/WarningButton.vue'

export default {
  components: { WarningButton, AccentButton },
  props: {
    syncStatus: {
      type: Object,
      required: true,
    },
    projectId: {
      type: String,
      required: true,
    },
  },
  emits: [
    'ok', 'hide',
  ],
  data: () => ({
    doUpdateRules: false,
  }),
  methods: {
    show () {
      this.$refs.dialog.show()
    },
    hide () {
      this.$refs.dialog.hide()
    },
    onDialogHide () {
      this.$emit('hide')
    },
    async doSync (doUpdateRules = false) {
      if (doUpdateRules) {
        this.doUpdateRules = true
        await this.$nextTick()
      }
      this.$refs.syncForm.submit()
    },
    onCancelClick () {
      this.hide()
    },
  },
}
</script>
